"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // ellipsis: boolean indicating whether to add a '...' after truncated text
  // breakWord: boolean indicating whether it is ok to truncate text mid-word
  truncate: function truncate(str, length) {
    var omission = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';
    var breakWord = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    // If we are less than or equal to max lenght, then just return the string
    if (!length || !str || str.length <= length) {
      return str;
    } // If we can just trim to meet max lenght, then do it


    if (str.trim().length <= length) {
      return str.trim();
    }

    var result = str.substring(0, length + (breakWord ? 0 : 1));
    result = breakWord ? result.trim() : result.substring(0, result.lastIndexOf(' ')); // Get rid of any trailing comma

    result = result.replace(/,+$/, '');
    return result + omission;
  },
  truncateMiddle: function truncateMiddle(str, length) {
    var omission = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';

    if (!str || !length) {
      return str;
    } // If length is less then omission characters, just return omission characters


    if (length < omission.length) {
      return omission;
    } // Calculated as a half of the overall number of chars we need to keep
    // not including the omission string.


    var keepCharsCount = length - omission.length; // It is ceiled to the smallest integer greater than or equal to a given
    // number of chars we want to keep in order to ensure that if there's
    // an odd number of such chars, more of them are added to the left side
    // of the resulting string.

    var leftSideCharsCount = Math.ceil(keepCharsCount / 2);
    var leftSideString = str.substring(0, leftSideCharsCount); // And the rest is appended at the end, after the omission string.

    var rightSideCharsCount = keepCharsCount - leftSideCharsCount;
    var rightSideString = str.substring(str.length - rightSideCharsCount);
    return "".concat(leftSideString).concat(omission).concat(rightSideString);
  },
  formatPhoneNumber: function formatPhoneNumber(phoneNumber) {
    var regexObj = /^(?:\+?1[-. ]?)?(?:\(?([0-9]{3})\)?[-. ]?)?([0-9]{3})[-. ]?([0-9]{4})$/;

    if (phoneNumber && regexObj.test(phoneNumber)) {
      var parts = phoneNumber.toString().match(regexObj);
      return "".concat(parts[1] ? '(' + parts[1] + ') ' : '').concat(parts[2], "-").concat(parts[3]);
    } else {
      return phoneNumber || '';
    }
  },
  formatWebsiteUrl: function formatWebsiteUrl(websiteUrl) {
    if (!websiteUrl) {
      return '';
    }

    return websiteUrl.match(/https?:\/\//) ? websiteUrl : 'http://' + websiteUrl;
  },
  formatPhoneUrl: function formatPhoneUrl(phoneUrl) {
    if (!phoneUrl) {
      return '';
    }

    return String(phoneUrl).replace(/((\(0\))|\s+)/g, '');
  },
  humanReadableFileSize: function humanReadableFileSize(size) {
    if (!size) {
      return '';
    }

    var i = Math.floor(Math.log(size) / Math.log(1024));
    return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/utils/stringUtils.js
// module id = 367
// module chunks = 25